import * as React from 'react'

import {
  ImageType,
  PersonalisationToggleContext,
} from './PersonalisationToggleContext'

export const PersonalisationToggleContextProvider: React.FunctionComponent<{}> = (
  props,
) => {
  const [isPersonalisationActive, setIsPersonalisationActive] = React.useState<
    boolean
  >(props.enableProductPersonalisationInterface || false)
  const [variantSku, setVariantSku] = React.useState<string>('')
  const [personalisationFields, setPersonalisationFields] = React.useState<{}>(
    {},
  )
  const [
    personalisationImagesContext,
    setPersonalisationImagesContext,
  ] = React.useState<{
    key: string
    images: ImageType[]
    thumbnails: ImageType[]
    zoom: ImageType[]
  }>({
    key: '',
    images: [{ alt: '', url: '' }],
    thumbnails: [{ alt: '', url: '' }],
    zoom: [{ alt: '', url: '' }],
  })

  return (
    <PersonalisationToggleContext.Provider
      value={{
        isPersonalisationActive,
        setIsPersonalisationActive,
        variantSku,
        setVariantSku,
        personalisationFields,
        setPersonalisationFields,
        personalisationImagesContext,
        setPersonalisationImagesContext,
      }}
    >
      {props.children}
    </PersonalisationToggleContext.Provider>
  )
}
